var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"left"},[_c('parkover'),_c('equipment')],1),_c('div',{staticClass:"bottom"},[_c('crudeoil'),_c('personnel'),_c('detection'),_c('monitor')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }